import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DropdownMenu from '../../DropdownMenu';
import * as H from './index.styled';
import { useRecoilState } from 'recoil';
import { userAtom } from '@/recoil/atoms/user.atom';
import { message } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';

const Header = () => {
  const navigate = useNavigate();
  const [user, setUser] = useRecoilState(userAtom);

  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = () => {
    if (isLoggingOut) {
      return;
    }
    setIsLoggingOut(true);
    setUser(null);
    sessionStorage.removeItem('token');
    navigate('/');

    setTimeout(() => {
      message.success('로그아웃되었습니다.');
      setIsLoggingOut(false);
    }, 1000);
  };



  const handleLogoClick = () => {
    switch (user?.role_name) {
      case 'admin':
        navigate('/admin/dashboard');
        break;
      case 'super':
        navigate('/admin/dashboard');
        break;
      case 'advertiser':
        navigate('/admin/campaign');
        break;
      default:
        navigate('/');
        break;
    }
  };

  return (
    <H.HeaderWrapper>
      <H.LogoBox>
        <H.Logo onClick={handleLogoClick}>wereward</H.Logo>
        {user?.role_name === 'admin' && <H.AdminText>Admin</H.AdminText>}
        {user?.role_name === 'super' && <H.AdminText>Super</H.AdminText>}
        {user?.role_name === 'advertiser' && <H.AdminText>Advertiser</H.AdminText>}
      </H.LogoBox>
      <H.MenuWrapper>
        <H.UserInfo onClick={handleLogout}>
          <div>Logout</div> <LogoutOutlined />
        </H.UserInfo>
      </H.MenuWrapper>
    </H.HeaderWrapper>
  );
};

export default Header;
